import styles from "./DataTable.module.css";
import { EmptyState } from "./EmptyState";
import { Spinner } from "./Spinner";

/**
 * columns: [{ key, header, render?(row) }]
 * selection: { selectedIds: Set, onToggle(id), onToggleAll(), idKey } -- omit to disable checkboxes
 */
export function DataTable({ columns, rows, rowKey = "id", loading, emptyTitle = "Nothing here yet", emptyDescription, emptyAction, selection, onRowClick }) {
  if (loading) return <Spinner />;
  if (!rows || rows.length === 0) return <EmptyState title={emptyTitle} description={emptyDescription} action={emptyAction} />;

  const allSelected = selection && rows.length > 0 && rows.every((r) => selection.selectedIds.has(r[rowKey]));

  return (
    <div className={styles.scrollWrap}>
      <table className={styles.table}>
        <thead>
          <tr>
            {selection && (
              <th className={styles.checkboxCell}>
                <input
                  type="checkbox"
                  aria-label="Select all rows"
                  checked={allSelected}
                  onChange={() => selection.onToggleAll(rows.map((r) => r[rowKey]))}
                  className={styles.checkbox}
                />
              </th>
            )}
            {columns.map((col) => (
              <th key={col.key}>{col.header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr
              key={row[rowKey]}
              className={onRowClick ? styles.clickable : undefined}
              onClick={() => onRowClick?.(row)}
            >
              {selection && (
                <td className={styles.checkboxCell} onClick={(e) => e.stopPropagation()}>
                  <input
                    type="checkbox"
                    aria-label={`Select row ${row[rowKey]}`}
                    checked={selection.selectedIds.has(row[rowKey])}
                    onChange={() => selection.onToggle(row[rowKey])}
                    className={styles.checkbox}
                  />
                </td>
              )}
              {columns.map((col) => (
                <td key={col.key}>{col.render ? col.render(row) : row[col.key]}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
